import type { FormattedNewWagerLineup } from '@library/types/newWagers';
import { PlayerLineupRow } from '@library/components/player/PlayerLineupRow';

import { useMemo } from 'react';

export interface MemberEntryCardLineupProps {
  lineup: FormattedNewWagerLineup;
}

export const MemberEntryCardLineup = ({
  lineup
}: MemberEntryCardLineupProps) => {
  const playerLineup = useMemo(() => {
    return lineup.map((lineupRow) => (
      <PlayerLineupRow key={lineupRow.id} lineupRow={lineupRow} />
    ));
  }, [lineup]);

  return (
    <div
      className="min-h-96 grow px-4"
      data-testid="member-entry-card-player-lineup"
    >
      {playerLineup}
    </div>
  );
};
